// extracted by mini-css-extract-plugin
export default {"NewSamplePage":"NewSamplePage_NewSamplePage__tFlys"};